import React from "react";
import { Helmet } from "react-helmet";
import Image from "react-bootstrap/Image";
import { Row, Col, Container } from "react-bootstrap";
import arrowIcon from "../assets/images/icons/arrow.png";
import { Link } from "react-router-dom";
import june2025 from "../assets/images/Newsletter/june-2025/banner.jpg";
import april2025 from "../assets/images/Newsletter/images/banner.png";
import october2024 from "../assets/images/Newsletter/Oct-2024/banner.png";
import september2025 from "../assets/images/Newsletter/August-2025/banner.png";
import july2023 from "../assets/images/Newsletter/images/july2023.jpg";
import april2023 from "../assets/images/Newsletter/banners/april-2023.jpg";
import october2022 from "../assets/images/Newsletter/banners/oct-2022.png";
import august2022 from "../assets/images/Newsletter/banners/aug-2022.webp";
import april2022 from "../assets/images/Newsletter/banners/april-2022.webp";
import october2021 from "../assets/images/Newsletter/banners/april-2022.webp";
import june2021 from "../assets/images/Newsletter/banners/june-2021.jpg";
import january2021 from "../assets/images/Newsletter/banners/jan-2021.webp";
import october2020 from "../assets/images/Newsletter/banners/oct-2020.webp";
import june2020 from "../assets/images/Newsletter/banners/jun-2020.webp";
import march2020 from "../assets/images/Newsletter/banners/mar-2020.webp";
import december2019 from "../assets/images/Newsletter/banners/dec-2019.webp";



import {
  ArrowRight,
} from "lucide-react";

import yearbook20242025 from "../assets/images/Yearbook/pdf/CS-Year-Book-2024.pdf";
import yearbook20232024 from "../assets/images/Yearbook/pdf/CS-YearBook-2023.pdf";
import yearbook20222023 from "../assets/images/Yearbook/pdf/CS-Year-Book-2022-23-2D_compressed.pdf";
import yearbook20212022 from "../assets/images/Yearbook/pdf/comsense-yearbook-2021-2022.pdf";
import yearbook20202021 from "../assets/images/Yearbook/pdf/comsense-yearbook-20-21.pdf";
import march2026 from "../assets/images/Newsletter/March-2026/banner.png";
import june2026 from "../assets/images/Newsletter/June-2026/banner.png";
import september2026 from "../assets/images/Newsletter/September-2026/banner.jpeg";

const newsletterCards = [
  {
    to: "/newsletter/september-2026",
    image: september2026,
    label: "September 2026",
    showArrow: true,
    headingClassName:
      "text-04467A d-flex align-items-center fw-600 mb-0 mt-auto fs-16",
  },
  {
    to: "/newsletter/june-2026",
    image: june2026,
    label: "June 2026",
    showArrow: true,
    headingClassName:
      "text-04467A d-flex align-items-center fw-600 mb-0 mt-auto fs-16",
  },
  {
    to: "/newsletter/march-2026",
    image: march2026,
    label: "March 2026",
    showArrow: true,
    headingClassName:
      "text-04467A d-flex align-items-center fw-600 mb-0 mt-auto fs-16",
  },
  {
    to: "/newsletter/april-2025",
    image: april2025,
    label: "April 2025",
    showArrow: false,
    headingClassName: "text-04467A fw-600 mb-0 mt-auto fs-16",
  },
  {
    to: "/newsletter/june-2025",
    image: june2025,
    label: "June 2025",
    showArrow: false,
    headingClassName:
      "text-04467A d-flex align-items-center fw-600 mb-0 mt-auto fs-16",
  },
  {
    to: "/newsletter/september-2025",
    image: september2025,
    label: "September 2025",
    showArrow: false,
    headingClassName: "text-04467A fw-600 mb-0 mt-auto fs-16",
  },
  {
    to: "/newsletter/october-2024",
    image: october2024,
    label: "October 2024",
    showArrow: false,
    headingClassName: "text-04467A fw-600 mb-0 mt-auto fs-16",
  },
  {
    to: "/newsletter/july-2023",
    image: july2023,
    label: "July 2023",
    showArrow: false,
    headingClassName: "text-04467A fw-600 mb-0 mt-auto fs-16",
  },
  {
    to: "/newsletter/april-2023",
    image: april2023,
    label: "April 2023",
    showArrow: false,
    headingClassName: "text-04467A fw-600 mb-0 mt-auto fs-16",
  },
  // Older newsletters retired from the grid — kept here (hidden: true) for reference.
  {
    to: "https://oldsite.comsensetechnologies.com/wp-content/uploads/2022/10/Comsense-Quarterly-Oct22-2.pdf",
    image: october2022,
    label: "October 2022",
    hidden: true,
  },
  {
    to: "/newsletter/august-2022",
    image: august2022,
    label: "August 2022",
    hidden: true,
  },
  {
    to: "/newsletter/april-2022",
    image: april2022,
    label: "April 2022",
    hidden: true,
  },
  {
    to: "/newsletter/october-2021",
    image: october2021,
    label: "October 2021",
    hidden: true,
  },
  {
    to: "/newsletter/june-2021",
    image: june2021,
    label: "June 2021",
    hidden: true,
  },
  {
    to: "/newsletter/january-2021",
    image: january2021,
    label: "January 2021",
    hidden: true,
  },
  {
    to: "/newsletter/october-2020",
    image: october2020,
    label: "October 2020",
    hidden: true,
  },
  {
    to: "/newsletter/june-2020",
    image: june2020,
    label: "June 2020",
    hidden: true,
  },
  {
    to: "/newsletter/march-2020",
    image: march2020,
    label: "March 2020",
    hidden: true,
  },
  {
    to: "/newsletter/december-2019",
    image: december2019,
    label: "December 2019",
    hidden: true,
  },
];

const Newsletter = () => {
  return (
    <>
      <Helmet>
        <title>AI & Salesforce Newsletter | Comsense Insights</title>

        <meta
          name="description"
          content="Explore Comsense newsletters for AI, Salesforce & Martech insights. Get updates on projects, trends & data-driven innovation."
        />

        <meta
          name="keywords"
          content="AI newsletter India, Salesforce newsletter Pune, Comsense Insights newsletter"
        />

        <meta name="robots" content="index, follow" />
        <meta name="author" content="Comsense Technologies" />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="AI & Salesforce Newsletter India | Comsense Insights & Updates"
        />
        <meta
          property="og:description"
          content="Stay updated with AI, Salesforce & Martech insights from Comsense."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://comsensetechnologies.com/newsletter"
        />
      </Helmet>
      <header class="masthead subPageHead data-cloud-header dataCloudBanner privacy-policy">
        <div class="container">
          <Row className="justify-content-center">
            <Col xl={12} lg={12}>
              {/* <Image src={shape3} className='shape3 d-none d-md-block' /> */}
              <h1 class="masthead-heading text-white text-center pt-4 pb-4 mb-0">
                <span className="fancy-text4 ps-1 pe-2 mb-0  z-0 text-EE0000  position-relative overflow-hiddens text-white">
                  Newsletter
                </span>
              </h1>
              <p className="mb-0 text-white text-center">
                Charting Expertise To Meaningful Insights
              </p>
              {/* <Image src={shape4} className='shape4 d-none d-md-block' />
                            <Image src={shape5} className='shape5 d-none d-md-block' /> */}
            </Col>
          </Row>
        </div>
      </header>

      {/* Row-1 */}
      <section class="page-section bg-white pt-80 pb-28">
        <Container>
          <Row className="align-items-stretch">
            {newsletterCards
              .filter((card) => !card.hidden)
              .map((card) => (
              <Col
                key={card.to}
                xl={3}
                lg={3}
                md={4}
                sm={6}
                xs={12}
                className="mb-3 mb-lg-4"
              >
                <Link
                  as={Link}
                  to={card.to}
                  className="text-decoration-none h-100 d-block"
                >
                  <div
                    className="bg-skyblue p-3 d-flex flex-column h-100"
                    style={{ borderRadius: "2px" }}
                  >
                    <div className="flex-grow-1 overflow-hidden mb-2">
                      <Image
                        src={card.image}
                        className="w-100 h-100"
                        style={{
                          objectFit: "cover",
                          objectPosition: "left",
                        }}
                      />
                    </div>
                    <h5 className={card.headingClassName}>
                      {card.label}
                      {card.showArrow && (
                        <ArrowRight className="ms-2" size={16} />
                      )}
                    </h5>
                  </div>
                </Link>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <section class="page-section bg-E2F1FE pt-80 pb-80">
        <Container>
          <Row className="align-items-center">
            <Col lg={12}>
              <div class="text-center d-flex align-items-center justify-content-start">
                <h2 class="section-heading section-heading-center fw-700 fs-2">
                  <span className="bordered-text bordered-text-start">
                    Yearbook
                  </span>
                </h2>
              </div>
            </Col>
          </Row>
          <Row className="align-items-center mt-5">
            <Col
              xl={2}
              lg={3}
              md={4}
              sm={4}
              xs={6}
              className="mb-3 mb-lg-3 position-relative"
              style={{ height: "200px" }}
            >
              <Link
                as={Link}
                onClick={() => window.scrollTo(0, 0)}
                to="/yearbook/2025"
                className="text-decoration-none"
              >
                <div
                  className="h-100 bg-white p-3 d-flex flex-column"
                  style={{ borderRadius: "2px" }}
                >
                  <Image
                    src={arrowIcon}
                    className="position-absolute"
                    style={{ top: "15px", right: "25px", width: "13px" }}
                  />
                  <h5
                    className="text-04467A fw-600 mb-0 mt-auto"
                    style={{ marginTop: "85px" }}
                  >
                    Comsense Yearbook 2025
                  </h5>
                </div>
              </Link>
            </Col>
            <Col
              xl={2}
              lg={3}
              md={4}
              sm={4}
              xs={6}
              className="mb-3 mb-lg-3 position-relative"
              style={{ height: "200px" }}
            >
              <a
                href={yearbook20242025}
                target="_blank"
                rel="noopener noreferrer"
                className="text-decoration-none"
              >
                <div
                  className="h-100 bg-white p-3 d-flex flex-column"
                  style={{ borderRadius: "2px" }}
                >
                  <Image
                    src={arrowIcon}
                    className="position-absolute"
                    style={{ top: "15px", right: "25px", width: "13px" }}
                  />
                  <h5
                    className="text-04467A fw-600 mb-0 mt-auto"
                    style={{ marginTop: "85px" }}
                  >
                    Comsense Yearbook 2024-2025
                  </h5>
                </div>
              </a>
            </Col>
            <Col
              xl={2}
              lg={3}
              md={4}
              sm={4}
              xs={6}
              className="mb-3 mb-lg-3 position-relative"
              style={{ height: "200px" }}
            >
              <a
                href={yearbook20232024}
                target="_blank"
                rel="noopener noreferrer"
                className="text-decoration-none"
              >
                <div
                  className="h-100 bg-white p-3 d-flex flex-column"
                  style={{ borderRadius: "2px" }}
                >
                  <Image
                    src={arrowIcon}
                    className="position-absolute"
                    style={{ top: "15px", right: "25px", width: "13px" }}
                  />
                  <h5
                    className="text-04467A fw-600 mb-0 mt-auto"
                    style={{ marginTop: "85px" }}
                  >
                    Comsense Yearbook 2023-2024
                  </h5>
                </div>
              </a>
            </Col>
            <Col
              xl={2}
              lg={3}
              md={4}
              sm={4}
              xs={6}
              className="mb-3 mb-lg-3 position-relative"
              style={{ height: "200px" }}
            >
              <a
                href={yearbook20222023}
                target="_blank"
                rel="noopener noreferrer"
                className="text-decoration-none"
              >
                <div
                  className="h-100 bg-white p-3 d-flex flex-column"
                  style={{ borderRadius: "2px" }}
                >
                  <Image
                    src={arrowIcon}
                    className="position-absolute"
                    style={{ top: "15px", right: "25px", width: "13px" }}
                  />
                  <h5
                    className="text-04467A fw-600 mb-0 mt-auto"
                    style={{ marginTop: "85px" }}
                  >
                    Comsense Yearbook 2022-2023
                  </h5>
                </div>
              </a>
            </Col>
            <Col
              xl={2}
              lg={3}
              md={4}
              sm={4}
              xs={6}
              className="mb-3 mb-lg-3 position-relative"
              style={{ height: "200px" }}
            >
              <a
                href={yearbook20212022}
                target="_blank"
                rel="noopener noreferrer"
                className="text-decoration-none"
              >
                <div
                  className="h-100 bg-white p-3 d-flex flex-column"
                  style={{ borderRadius: "2px" }}
                >
                  <Image
                    src={arrowIcon}
                    className="position-absolute"
                    style={{ top: "15px", right: "25px", width: "13px" }}
                  />
                  <h5
                    className="text-04467A fw-600 mb-0 mt-auto"
                    style={{ marginTop: "85px" }}
                  >
                    Comsense Yearbook 2021-2022
                  </h5>
                </div>
              </a>
            </Col>
            <Col
              xl={2}
              lg={3}
              md={4}
              sm={4}
              xs={6}
              className="mb-3 mb-lg-3 position-relative"
              style={{ height: "200px" }}
            >
              <a
                href={yearbook20202021}
                target="_blank"
                rel="noopener noreferrer"
                className="text-decoration-none"
              >
                <div
                  className="h-100 bg-white p-3 d-flex flex-column"
                  style={{ borderRadius: "2px" }}
                >
                  <Image
                    src={arrowIcon}
                    className="position-absolute"
                    style={{ top: "15px", right: "25px", width: "13px" }}
                  />
                  <h5
                    className="text-04467A fw-600 mb-0 mt-auto"
                    style={{ marginTop: "85px" }}
                  >
                    Comsense Yearbook 2020-2021
                  </h5>
                </div>
              </a>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Newsletter;
